const convertDateToString = (date) => {
  if (!date) {
    return ''
  }
  const day = `${date.getDate().toString().padStart(2, 0)}`
  const month = `${(date.getMonth() + 1).toString().padStart(2, 0)}`
  const year = `${date.getFullYear().toString().padStart(2, 0)}`

  return `${day}/${month}/${year}`
}

export default convertDateToString
